import { render, staticRenderFns } from "./UniDetailCampus.vue?vue&type=template&id=1e2617dc&scoped=true&"
import script from "./UniDetailCampus.vue?vue&type=script&lang=js&"
export * from "./UniDetailCampus.vue?vue&type=script&lang=js&"
import style0 from "./UniDetailCampus.vue?vue&type=style&index=0&id=1e2617dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2617dc",
  null
  
)

component.options.__file = "UniDetailCampus.vue"
export default component.exports